module.exports = __webpack_public_path__ + "img/media_tv_radio.ac1a8143.jpg";